import React, { useState } from 'react';
import SEOHead from '../components/SEOHead';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    build: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>
      </svg>
    ),
    flash: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M7 2v11h3v9l7-12h-4l4-8z"/>
      </svg>
    ),
    home: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
      </svg>
    ),
    business: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
      </svg>
    ),
    medical_services: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM4 8h2v8H4zm0-2h2V4H4zm12 0h2V4h-2zm0 2h2v8h-2zM8 20h8v-2H8zm0-16h8V2H8z"/>
      </svg>
    ),
    spa: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M8.55 12c-1.07-.71-2.25-1.27-3.53-1.61 1.28.34 2.46.9 3.53 1.61zm10.43-1.61c-1.29.34-2.49.91-3.57 1.64 1.08-.73 2.28-1.3 3.57-1.64zM15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.43 7.63 1.31-.68 2.79-1.07 4.33-1.07s3.02.39 4.33 1.07z"/>
      </svg>
    ),
    fitness_center: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29l-1.43-1.43z"/>
      </svg>
    ),
    content_cut: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM12 3l7 7h3v-1L12 3z"/>
      </svg>
    ),
    pets: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M4.5 9.5C3.12 9.5 2 8.38 2 7s1.12-2.5 2.5-2.5S7 5.62 7 7s-1.12 2.5-2.5 2.5zm15 0C18.12 9.5 17 8.38 17 7s1.12-2.5 2.5-2.5S22 5.62 22 7s-1.12 2.5-2.5 2.5zm-3 7.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zm-9 0C6.12 17 5 15.88 5 14.5S6.12 12 7.5 12s2.5 1.12 2.5 2.5S8.88 17 7.5 17zm4.5 2c-3.04 0-5.5-2.46-5.5-5.5S8.96 8 12 8s5.5 2.46 5.5 5.5S15.04 19 12 19z"/>
      </svg>
    ),
    school: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
      </svg>
    ),
    psychology: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M21,9V7L15,1H5C3.89,1 3,1.89 3,3V7H1V9H3V15H1V17H3V21C3,22.11 3.89,23 5,23H19C20.11,23 21,22.11 21,21V17H23V15H21V9H23V7H21M19,21H5V3H13V7H19V21Z"/>
      </svg>
    ),
    self_improvement: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M21,9V7L15,1H5C3.89,1 3,1.89 3,3V7H1V9H3V15H1V17H3V21C3,22.11 3.89,23 5,23H19C20.11,23 21,22.11 21,21V17H23V15H21V9H23V7H21M19,21H5V3H13V7H19V21Z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const IndustriesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const industries = [
    // Home Services
    { name: 'Plumbers', path: '/plumbers', description: 'Emergency repairs & installations', category: 'home', icon: 'build' },
    { name: 'Electricians', path: '/electricians', description: 'Electrical repairs & installations', category: 'home', icon: 'flash' },
    { name: 'HVAC', path: '/hvac', description: 'Heating & cooling services', category: 'home', icon: 'home' },
    { name: 'Locksmiths', path: '/locksmiths', description: 'Emergency lockout services', category: 'home', icon: 'build' },
    { name: 'Contractors', path: '/contractors', description: 'Home improvement projects', category: 'home', icon: 'build' },
    { name: 'Roofers', path: '/roofers', description: 'Roof repairs & installations', category: 'home', icon: 'home' },
    { name: 'Landscapers', path: '/landscapers', description: 'Lawn care & landscaping', category: 'home', icon: 'home' },
    { name: 'Cleaning', path: '/cleaning', description: 'Residential & commercial cleaning', category: 'home', icon: 'home' },
    { name: 'Garage Door Repair', path: '/garagedoor', description: 'Emergency garage door services', category: 'home', icon: 'home' },
    { name: 'Appliance Repair', path: '/appliance-repair', description: 'Refrigerator, washer & dryer repair', category: 'home', icon: 'build' },
    { name: 'Pest Control', path: '/pest-control', description: 'Pest elimination & prevention', category: 'home', icon: 'home' },
    { name: 'Duct & Gutter Cleaning', path: '/duct-gutter-cleaning', description: 'HVAC duct & gutter maintenance', category: 'home', icon: 'home' },
    { name: 'Water Damage Restoration', path: '/water-damage-restoration', description: 'Water damage & mold remediation', category: 'home', icon: 'home' },
    
    // Professional Services
    { name: 'Real Estate', path: '/realestate', description: 'Property sales & rentals', category: 'professional', icon: 'business' },
    { name: 'Real Estate Brokerages', path: '/real-estate-brokerages', description: 'Lead capture & client management', category: 'professional', icon: 'business' },
    { name: 'Tax Prep', path: '/taxprep', description: 'Tax preparation services', category: 'professional', icon: 'business' },
    { name: 'Law Firms', path: '/lawfirms', description: 'Legal consultations & services', category: 'professional', icon: 'business' },
    { name: 'Insurance', path: '/insurance', description: 'Insurance quotes & claims', category: 'professional', icon: 'business' },
    { name: 'Property Management', path: '/property-management', description: 'Tenant & maintenance coordination', category: 'professional', icon: 'business' },
    
    // Automotive Services
    { name: 'Auto Repair', path: '/autorepair', description: 'Car repairs & maintenance', category: 'automotive', icon: 'build' },
    { name: 'Tire Shops', path: '/tire-shops', description: 'Tire sales & installation', category: 'automotive', icon: 'build' },
    { name: 'Oil Change & Lube', path: '/oil-change-lube', description: 'Quick oil change services', category: 'automotive', icon: 'build' },
    { name: 'Body Shops', path: '/body-shops', description: 'Collision repair & paint work', category: 'automotive', icon: 'build' },
    { name: 'Glass Repair & Tinting', path: '/glass-repair-tinting', description: 'Windshield repair & window tinting', category: 'automotive', icon: 'build' },
    
    // Healthcare & Wellness
    { name: 'Medical', path: '/medical', description: 'Healthcare & dental practices', category: 'healthcare', icon: 'medical_services' },
    { name: 'Dentists', path: '/dentist', description: 'Dental care & oral health services', category: 'healthcare', icon: 'medical_services' },
    { name: 'Therapists', path: '/therapist', description: 'Mental health & counseling services', category: 'healthcare', icon: 'psychology' },
    { name: 'Massage Therapy', path: '/massage', description: 'Therapeutic & relaxation massage', category: 'healthcare', icon: 'spa' },
    { name: 'Chiropractors', path: '/chiropractor', description: 'Spinal adjustments & pain relief', category: 'healthcare', icon: 'medical_services' },
    { name: 'Physical Therapy', path: '/physicaltherapy', description: 'Rehabilitation & movement therapy', category: 'healthcare', icon: 'medical_services' },
    { name: 'Veterinarians', path: '/veterinarian', description: 'Pet care & veterinary services', category: 'healthcare', icon: 'pets' },
    
    // Beauty & Wellness
    { name: 'Med Spas', path: '/medspa', description: 'Botox, facials & aesthetic treatments', category: 'beauty', icon: 'spa' },
    { name: 'Nail Salons', path: '/nailsalon', description: 'Manicures, pedicures & nail art', category: 'beauty', icon: 'spa' },
    { name: 'Hair Salons', path: '/hairsalon', description: 'Cuts, color & styling services', category: 'beauty', icon: 'content_cut' },
    { name: 'Fitness Training', path: '/fitness', description: 'Personal training & fitness coaching', category: 'beauty', icon: 'fitness_center' }
  ];

  const categories = [
    { id: 'all', name: 'All Industries', count: industries.length },
    { id: 'home', name: 'Home Services', count: industries.filter(i => i.category === 'home').length },
    { id: 'professional', name: 'Professional Services', count: industries.filter(i => i.category === 'professional').length },
    { id: 'automotive', name: 'Automotive Services', count: industries.filter(i => i.category === 'automotive').length },
    { id: 'healthcare', name: 'Healthcare & Wellness', count: industries.filter(i => i.category === 'healthcare').length },
    { id: 'beauty', name: 'Beauty & Wellness', count: industries.filter(i => i.category === 'beauty').length }
  ];

  const filteredIndustries = selectedCategory === 'all' 
    ? industries 
    : industries.filter(industry => industry.category === selectedCategory);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "AI Receptionist for All Industries - Complete Service Directory",
    "description": "Discover AI receptionist services for every industry. From plumbers to dentists, we serve 35+ industries with 24/7 automated phone answering.",
    "url": "https://receptioneer.ai/industries",
    "mainEntity": {
      "@type": "ItemList",
      "numberOfItems": industries.length,
      "itemListElement": industries.map((industry, index) => ({
        "@type": "Service",
        "position": index + 1,
        "name": `AI Receptionist for ${industry.name}`,
        "description": industry.description,
        "url": `https://receptioneer.ai${industry.path}`
      }))
    }
  };

  return (
    <>
      <SEOHead
        title="AI Receptionist for All Industries | 36+ Service Types Supported"
        description="Complete directory of AI receptionist services for every industry. From plumbers to dentists, massage therapists to law firms - never miss another customer call."
        keywords="ai receptionist industries, virtual receptionist services, automated phone answering, business phone service, appointment booking all industries, call handling services"
        canonical="https://receptioneer.ai/industries"
        ogTitle="AI Receptionist for All Industries - 36+ Service Types Supported"
        ogDescription="Complete directory of AI receptionist services for every industry. From home services to healthcare - never miss another customer call."
        ogImage="https://receptioneer.ai/images/og-image.jpg"
        structuredData={structuredData}
      />
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Try Live Demo
              </a>
              <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Login
              </button>
            </div>
          </div>
        </header>

        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white py-16 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
              AI Receptionist for
              <br />
              <span className="text-blue-200">Every Industry</span>
            </h1>
            
            <p className="text-xl text-blue-100 mb-8 leading-relaxed max-w-3xl mx-auto">
              From emergency plumbing calls to therapy appointments, our AI receptionist understands your industry's unique needs. 
              <strong className="text-white">Designed for 36+ industries with specialized knowledge.</strong>
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <a
                href="tel:+17863845350"
                className="flex items-center justify-center gap-3 bg-white text-blue-900 hover:bg-blue-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                <MaterialIcon name="phone" className="w-5 h-5" />
                Test It Live
              </a>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-2xl mx-auto">
              <div className="text-center">
                <div className="text-3xl font-black text-white">36+</div>
                <div className="text-blue-200 text-sm">Industries Supported</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-black text-white">$399</div>
                <div className="text-blue-200 text-sm">Per Month</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-black text-white">24/7</div>
                <div className="text-blue-200 text-sm">Always Available</div>
              </div>
            </div>
          </div>
        </section>

        {/* Category Filter */}
        <section className="py-8 px-6 bg-gray-50 border-b">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-wrap gap-4 justify-center">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-6 py-3 rounded-xl font-bold text-sm transition-all duration-300 ${
                    selectedCategory === category.id
                      ? 'bg-blue-900 text-white shadow-lg'
                      : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
                  }`}
                >
                  {category.name} ({category.count})
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Industries Grid */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl lg:text-4xl font-black mb-4 text-gray-900">
                {selectedCategory === 'all' ? 'All Industries' : categories.find(c => c.id === selectedCategory)?.name}
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Choose your industry to see how our AI receptionist can transform your business
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {filteredIndustries.map((industry, index) => (
                <a
                  key={index}
                  href={industry.path}
                  className="bg-white rounded-2xl p-6 border border-gray-200 hover:border-blue-300 hover:shadow-lg transition-all duration-300 group"
                >
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center group-hover:bg-blue-100 transition-colors">
                      <MaterialIcon name={industry.icon} className="w-6 h-6 text-blue-600" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 group-hover:text-blue-900 transition-colors">
                        {industry.name}
                      </h3>
                    </div>
                  </div>
                  
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    {industry.description}
                  </p>
                  
                  <div className="flex items-center justify-end">
                    <span className="text-blue-600 text-sm font-semibold group-hover:text-blue-700">
                      Learn more →
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 px-6 bg-blue-900 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-6">
              Don't See Your Industry?
            </h2>
            
            <p className="text-xl text-blue-100 mb-8 leading-relaxed">
              Our AI receptionist adapts to any business type. From specialized services to unique industries, 
              we can customize the perfect phone answering solution for you.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+17863845350"
                className="flex items-center justify-center gap-3 bg-white text-blue-900 hover:bg-blue-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                <MaterialIcon name="phone" className="w-5 h-5" />
                Call Us: (786) 384-5350
              </a>
              
              <a
                href="mailto:support@receptioneer.ai"
                className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-blue-900 px-8 py-4 rounded-xl font-bold text-lg transition-all duration-300"
              >
                Contact Support
              </a>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default IndustriesPage;